import clsx from 'clsx'
import { type ReactNode } from 'react'
import { ReactComponent as Logo } from '../../assets/svgs/logo.svg'

interface AuthLayoutProps {
  children: ReactNode
  title?: string
  subtitle?: string
  withNavbar?: boolean
}

export const AuthLayout = ({
  title,
  subtitle,
  withNavbar,
  children,
}: AuthLayoutProps) => {
  return (
    <div className="flex items-center justify-center min-h-screen w-full">
      <div
        className={clsx(
          'w-full max-w-lg md:h-fit px-8 py-14',
          {
            'lg:min-h-[calc(100vh_-_400px)]': withNavbar,
            'min-h-screen': !withNavbar,
          }
        )}
      >
        <div className="flex flex-col w-full h-auto p-10 rounded-lg bg-white shadow-lg">
          <header className="mb-6">
            <div className="flex justify-center w-full mb-4">
              <Logo className="w-36 h-auto" />
            </div>
            {!!title && (
              <h1 className="text-2xl font-semibold text-gray-800 text-center mb-2">
                {title}
              </h1>
            )}
            {!!subtitle && (
              <p className="text-sm font-normal text-gray-600 text-center">
                {subtitle}
              </p>
            )}
          </header>
          <div>{children}</div>
        </div>
      </div>
    </div>
  )
}
